import http from "./HttpService";

const BASE_SERVICE_URL = "organization-service";

export default {
  getBranchDetails({header, branchUuid}) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v2/customer/branch/view/details/${branchUuid}`,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getPublicBranchDetails({header, branchUuid}) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v2/public/customer/branch/view/details/${branchUuid}`,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  }
};
